module.exports = __webpack_public_path__ + "static/media/Logo_Trust_NEAS.161766ad.png";